import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Input, InputNumber, Button, Select, Row, Col } from "antd";
import Swal from "sweetalert2";
import Loader from "../components/Loader";
import Error from "../components/Error";
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const AdminUpdateRoomScreen = ({match}) =>{
const user = JSON.parse(localStorage.getItem("currentUser"));
  useEffect(() => {
    if (!user || user.isAdmin == false) {
      window.location.href = "/home";
    }
  }, []);
const roomId = match.params.roomid; 
console.log(roomId);
  const { Option } = Select;

  const [room, setRoom] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [form] = Form.useForm();


  useEffect(() => {
  const fetchRoom = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`/api/rooms/getbyId/${roomId}`);
        const { imageurls } = data;
         form.setFieldsValue({
      imageurl1: imageurls[0],
      imageurl2: imageurls[1],
      imageurl3: imageurls[2],
      });
      form.setFieldsValue({
            positionX: data.transform.position.x,
            positionY: data.transform.position.y,
            positionZ: data.transform.position.z,
            rotationX: data.transform.rotation.x,
            rotationY: data.transform.rotation.y,
            rotationZ: data.transform.rotation.z,
            scaleX: data.transform.scale.x,
            scaleY: data.transform.scale.y,
            scaleZ: data.transform.scale.z,
           });

    // setRoom(data);
      form.setFieldsValue(data);
    } catch (error) {
      console.log(error);
      setError(error);
    }
    setLoading(false);
  };

  fetchRoom();
}, [form, roomId]);


  const onFinish = async (values) => {
    console.log(values);
    setError("");
    setLoading(true);
    const { _id, ...updatedRoom } = values;
    try {
        const { data } = await axios.put(`/api/rooms/${roomId}`, updatedRoom);
        Swal.fire("Congratulations", "Your Room Updated Successfully", "success"); 
    } catch (error) {
        console.log(error);
        setError(error);
        Swal.fire("Oops", "Error:" + error, "error");
    }

    setLoading(false);
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <div className="row">
      {loading ? (
        <Loader></Loader>
      ) : error.length > 0 ? (
        <Error msg={error}></Error>
      ) : (
        <div className="col-md-12">
          <Form
            {...layout}
            form={form}
            name="control-hooks"
            initialValues={room}
            onFinish={onFinish}
          >
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="roomnumber"
              label="Room Number"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>


              <Form.Item label="Position">
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      name="positionX"
                      noStyle
                    >
                      <InputNumber placeholder="X" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="positionY"
                      noStyle
                    >
                      <InputNumber placeholder="Y" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="positionZ"
                      noStyle
                    >
                      <InputNumber placeholder="Z" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item label="Rotation">
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      name="rotationX"
                      noStyle
                    >
                      <InputNumber placeholder="X" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="rotationY"
                      noStyle
                    >
                      <InputNumber placeholder="Y" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="rotationZ"
                      noStyle
                    >
                      <InputNumber placeholder="Z" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item label="Scale">
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      name="scaleX"
                      noStyle
                    >
                      <InputNumber placeholder="X" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="scaleY"
                      noStyle
                    >
                      <InputNumber placeholder="Y" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="scaleZ"
                      noStyle
                    >
                      <InputNumber placeholder="Z" min={-1000} max={1000} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>


            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              {/* <Input /> */}
              <Input.TextArea rows={4} />
            </Form.Item>
            {/* <Form.Item
              name="maxcount"
              label="MaxRooms"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber min={1} defaultChecked={1} />
            </Form.Item> */}
            {/* <Form.Item
              name="phonenumber"
              label="Phone Number"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item> */}
            <Form.Item
              name="rentperday"
              label="Rent Per Day"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <InputNumber min={1} defaultChecked={1} />
            </Form.Item>
            <Form.Item
              name="imageurl1"
              label="imageurl1"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="imageurl2"
              label="imageurl2"
              rules={[
                {
                  //required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="imageurl3"
              label="imageurl3"
              rules={[
                {
                  //required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="type"
              label="Room Type"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select placeholder="Select a room type" allowClear>
                <Option value="deluxe">Deluxe Room</Option>
                <Option value="junior">Junior Suite</Option>
                <Option value="Non-deluxe">Premium Room</Option>
                <Option value="Others">Others</Option>
              </Select>
            </Form.Item>
            <Form.Item {...tailLayout}>
              <Button type="success" htmlType="submit">
                Update Info
              </Button>
              <Button type="danger" htmlType="button" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
    </div>
  );
}

export default AdminUpdateRoomScreen;